<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container class="px-10 pt-8">
        <p class="subtitle-1 font-weight-bold mb-2">Unpaid Deposit</p>
        <v-row>
          <v-col class="py-2" cols="12" sm="12" md="12">
            <p>
              You left the deposit of this tenant as unpaid. Would you like to
              create a payment request with the deposit amount?
            </p>
          </v-col>
        </v-row>
        <v-card-actions class="pt-6">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="finish('yes')">Yes</v-btn>
          <v-btn color="grey darken-1" text @click="finish('no')">No</v-btn>
          <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      paymentId: -1,
      tenantName: '',
      total: 0,
      creditBalance: null,
      step: 1
    }
  },
  methods: {
    async open() {
      this.dialog = true

      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async finish(yes) {
      this.dialog = false
      return this.resolve(yes)
    },
    cancel() {
      this.dialog = false
      return this.resolve(false)
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
